import script from "./DemoCharts.vue?vue&type=script&setup=true&name=DemoCharts&lang=js"
export * from "./DemoCharts.vue?vue&type=script&setup=true&name=DemoCharts&lang=js"

import "./DemoCharts.vue?vue&type=style&index=0&id=4bf6690c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bf6690c"]])

export default __exports__